import { gql, TypedDocumentNode } from '@apollo/client';
import type { Vendor } from '../models/Vendor';

export const GET_VENDORS_QUERY: TypedDocumentNode<{ vendors: Vendor[] }> = gql`
  query GetVendors {
    vendors(order: { name: ASC }) {
      id,
      name,
      address,
      city,
      state,
      zip,
      contactId,
      contact {
        id,
        name,
        email,
        phone
      }
    }
  }
`;

export const GET_VENDOR_BY_ID_QUERY: TypedDocumentNode<{ vendor: Vendor }, { id: number, inventoryItemsFilter?: {} }> = gql`
  query GetVendorById($id: Int!, $inventoryItemsFilter: InventoryItemFilterInput) {
    vendor: vendorById(id: $id) {
      id,
      name,
      address,
      city,
      state,
      zip,
      contactId,
      contact {
        id,
        name,
        email,
        phone
      },
      inventoryItems(where: $inventoryItemsFilter) {
        id,
        quantityOnHand,
        costPerUnit,
        quantityOrdered,
        isArchived,
        lotNumber,
        surchargePerUnit,
        shippingCostPerUnit,
        orderDetails,
        totalCostPerUnit,
        totalOrderedCost,
        itemId,
        item {
          id,
          name,
          unitType,
          isIngredient,
          description,
          orderNotes,
          standardShippingQuantity,
          minOrderQuantity,
          maxOrderQuantity,
          outOfStock
        },
        purchaseOrderId,
        purchaseOrder {
          id,
          dateTimePurchased
        }
      },
      purchaseOrders {
        id,
        dateTimePurchased,
        vendorId,
        vendor {
          id,
          name
        },
        totalOrderCost
      }
    }
  }
`;
